export default "__VITE_ASSET__BhA6AP3K__"